import Products from './ProductsPage';

export default Products;
